import * as Yup from 'yup';

import { FLOW_CODES } from '@hero/constants';

import { withMerchantFunction } from '../../utils/merchantUtils';

import {
  getContactsRule,
  getExperienceSettingsRule,
  getMetaRule,
  getNameRule,
  getPaymentMethodRule,
  getProductsRule,
  getSettingsRule
} from './common';

//! Step 5
const getReviewAndPayRule = ({
  isPaymentMethodRequired = false,
  isEndDateRequired = true,
  isInputMessageRequired = true,
  isPoNumberRequired = false,
  isCostCenterRequired = false,
  flowCode = FLOW_CODES.standard
}) => {
  return Yup.object().shape({
    products: getProductsRule(),
    paymentMethod: getPaymentMethodRule(isPaymentMethodRequired),
    name: getNameRule('recognition'),
    experienceSettings: getExperienceSettingsRule({ isInputMessageRequired, flowCode }),
    settings: getSettingsRule({ isEndDateRequired }),
    contacts: getContactsRule({ featureName: 'recognition', flowCode }),
    meta: getMetaRule({ isPoNumberRequired, isCostCenterRequired })
  });
};

const getReviewAndPaySchema = withMerchantFunction({
  defaultFunction: getReviewAndPayRule,
  fileName: 'recognitions',
  folderPath: 'validations'
});

export { getReviewAndPaySchema };
